import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { featureRequestRequesterApiRef } from '../../apis';

export const useFeatureRequestProjectsByRequester = () => {
  const api = useApi(featureRequestRequesterApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'by-requester', 'projects'],
    queryFn: () => api.fetchProjectsByRequester(),
    staleTime: 5 * 60 * 1000,
  });
};
